import { ActionTree } from 'vuex';
import { RootState } from '../../types';
import { TrainerPayrollState } from './types';
import { Logger } from 'fsts';
import moduleUtils from '../moduleUtils';
import { defaultBackendTrainerPayroll } from '@/shared/backend/trainerPayroll';
import { i18nGlobal } from '@/i18n';
import DownloadUtils from '@/shared/utils/downloadUtils';
import { TrainerPayroll } from '@/shared/model/trainerPayroll';
import { TrainerHoursStatusEnum } from '@/shared/model/trainerHours';

const logger = new Logger('actions.trainerPayrolls');
export const actions: ActionTree<TrainerPayrollState, RootState> = {
  getTrainerPayrolls(
    { commit, getters },
    payload: {
      searchParams?: any;
      year?: number;
      month?: number;
      trainerId?: string;
      status?: TrainerHoursStatusEnum;
      locationId?: string;
      departmentId?: string;
    }
  ) {
    commit('setTrainerPayrollsIsLoading', true);
    const searchParams =
      payload?.searchParams ?? getters.getTrainerPayrollsSearchParams;

    return defaultBackendTrainerPayroll
      .getTrainerPayrolls(
        searchParams,
        payload?.year,
        payload?.month,
        payload?.trainerId,
        payload?.status,
        payload?.departmentId,
        payload?.locationId
      )
      .then((resp) => {
        commit('setTrainerPayrolls', resp.data);
        return resp.data;
      })
      .catch((err) => {
        moduleUtils.error('error', commit, err, logger);
        throw err;
      })
      .finally(() => {
        commit('setTrainerPayrollsIsLoading', false);
      });
  },
  updateTrainerPayroll({ commit }, trainerPayroll: TrainerPayroll) {
    return defaultBackendTrainerPayroll
      .updateTrainerPayroll(trainerPayroll)
      .then(() => {
        moduleUtils.ok(i18nGlobal.t(`success.trainer_payroll_update`), commit);
      })
      .catch((err) => {
        moduleUtils.error('error', commit, err, logger);
        throw err;
      });
  },
  exportTrainerPayrolls(
    { commit },
    payload: {
      year?: number;
      months?: number[];
      trainerIds?: string[];
      statuses?: TrainerHoursStatusEnum[];
      markExportedTrainerHoursPaid?: boolean;
      exportPreviouslyExportedTrainerHours?: boolean;
    }
  ) {
    commit('setTrainerPayrollsIsLoading', true);
    const lang = i18nGlobal.locale.value;
    return defaultBackendTrainerPayroll
      .exportTrainerPayrolls(
        payload.year,
        payload.months,
        payload.trainerIds,
        payload.statuses,
        payload.markExportedTrainerHoursPaid,
        payload.exportPreviouslyExportedTrainerHours,
        lang
      )
      .then(DownloadUtils.openDownloadedFileInBrowser)
      .catch((err) => {
        moduleUtils.error('error', commit, err, logger);
        throw err;
      })
      .finally(() => {
        commit('setTrainerPayrollsIsLoading', false);
      });
  },

  countTrainerPayrollsForExport(
    { commit },
    payload: {
      year?: number;
      months?: number[];
      trainerIds?: string[];
      statuses?: TrainerHoursStatusEnum[];
      exportPreviouslyExportedTrainerHours?: boolean;
    }
  ) {
    return defaultBackendTrainerPayroll
      .countTrainerPayrollsForExport(
        payload.year,
        payload.months,
        payload.trainerIds,
        payload.statuses,
        payload.exportPreviouslyExportedTrainerHours
      )
      .then((resp) => resp.data)
      .catch((err) => {
        moduleUtils.error('error', commit, err, logger);
        throw err;
      });
  },
};
